import React from "react";
import "./ProducerHubFilter.scss";
import { ReactComponent as DollarIcon } from "@assets/icons/dollar.svg";
import { ReactComponent as OrderIcon } from "@assets/icons/order.svg";
import { ReactComponent as ListIcon } from "@assets/icons/view-list.svg";
import { ReactComponent as ChartIcon } from "@assets/icons/chart.svg";

interface IProducerHubFilter {
  selectedOption: any;
  setSelectedOption: (option: any) => void;
  isLeaderboard: boolean;
}

const ProducerHubFilter: React.FC<IProducerHubFilter> = ({
  selectedOption,
  setSelectedOption,
  isLeaderboard,
}) => {
  const handleUpdateSelectedOption = (key: string, value: number) => {
    setSelectedOption({ ...selectedOption, [key]: value });
  };

  return (
    <div className="ProducerHubFilter">
      <div className="chart-options">
        <div
          className={`option-item ${
            selectedOption.date == 1 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 1)}
        >
          1M
        </div>
        <div
          className={`option-item ${
            selectedOption.date == 2 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 2)}
        >
          6M
        </div>
        <div
          className={`option-item ${
            selectedOption.date == 3 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 3)}
        >
          YTD
        </div>
        <div
          className={`option-item ${
            selectedOption.date == 4 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 4)}
        >
          1Y
        </div>
        <div
          className={`option-item ${
            selectedOption.date == 5 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 5)}
        >
          5Y
        </div>
        <div
          className={`option-item ${
            selectedOption.date == 6 ? "selected" : ""
          }`}
          onClick={() => handleUpdateSelectedOption("date", 6)}
        >
          All
        </div>
      </div>
      {isLeaderboard && (
        <>
          <div className="currency-options">
            <div
              className={`option-item ${
                selectedOption.currency == 1 ? "selected" : ""
              }`}
              onClick={() => handleUpdateSelectedOption("currency", 1)}
            >
              <DollarIcon className="option-icon" />
            </div>
            <div
              className={`option-item ${
                selectedOption.currency == 2 ? "selected" : ""
              }`}
              onClick={() => handleUpdateSelectedOption("currency", 2)}
            >
              <OrderIcon className="option-icon" />
            </div>
          </div>
          <div className="list-options">
            <div
              className={`option-item ${
                selectedOption.list == 1 ? "selected" : ""
              }`}
              onClick={() => handleUpdateSelectedOption("list", 1)}
            >
              <ListIcon className="option-icon" />
            </div>
            <div
              className={`option-item ${
                selectedOption.list == 2 ? "selected" : ""
              }`}
              onClick={() => handleUpdateSelectedOption("list", 2)}
            >
              <ChartIcon className="option-icon" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProducerHubFilter;
